export * from './config-resource.module';
export * from './config-resource.service';
